import { createStyles } from '@mantine/core';
import { DataTableProps, DataTable as MantineDataTable } from 'mantine-datatable';

export function DataTable<T = unknown>(props: DataTableProps<T>) {
  const { classes } = useStyles();
  const { records: propRecords, idAccessor: propIdAccessor, ...rest } = props;
  const records = propRecords ?? [];
  const recordsWithIds =
    Array.isArray(records) && records.every((record) => record && typeof record === 'object')
      ? records.map((record, index) => ({
          ...(record as Record<string, unknown>),
          _rowId: (record as Record<string, unknown>)._rowId ?? index,
        }))
      : records;
  const hasAllIds =
    Array.isArray(recordsWithIds) &&
    recordsWithIds.every(
      (record) =>
        record &&
        typeof record === 'object' &&
        (record as Record<string, unknown>).id != null
    );
  const idAccessor = propIdAccessor ?? (hasAllIds ? 'id' : '_rowId');

  return (
    <MantineDataTable
      scrollAreaProps={{ type: 'always', style: { paddingBottom: 25 } }}
      classNames={classes}
      minHeight={300}
      withBorder={false}
      withColumnBorders={false}
      rowBorderColor={'transparent'}
      striped
      highlightOnHover
      {...rest}
      idAccessor={idAccessor}
      records={recordsWithIds as DataTableProps<T>['records']}
    />
  );
}

const useStyles = createStyles((theme) => ({
  root: {
    '& td': {
      verticalAlign: 'middle',
    },
  },
  header: {
    '& th': {
      backgroundColor: '#F5FAFF',
      verticalAlign: 'middle',
    },
    '& thead': {
      borderBottomWidth: 0,
    },
    '& th div': {
      fontSize: '0.95em',
      textOverflow: 'unset',
      whiteSpace: 'break-spaces',
      color: 'black',
      fontWeight: 1900,
      lineHeight: 1,
    },
  },
}));
